<template>
    <div>
        <div class="vx-card p-2">
            <div class="vx-row">
                <div class="vx-col md:w-1/2 w-full flex items-center">
                    <h4>Cấu hình tổng đài</h4>
                </div>
                <div class="vx-col md:w-1/2 w-full flex justify-end gap-3">
                    <vs-button color="primary" icon-pack="feather" icon="icon-settings" v-if="!isChangeConfig"
                        @click="changeConfig">
                        {{ $t('settings.addSetting') }}
                    </vs-button>
                    <vs-button @click="checkDataSave" icon-pack="feather" icon="icon-check" v-if="isChangeConfig">
                        {{ $t('button.save') }}
                    </vs-button>
                    <vs-button class="" color="danger" type="border" icon-pack="feather" icon="icon-x"
                        @click="cancelSetting" v-if="isChangeConfig">
                        {{ $t('settings.close') }}
                    </vs-button>

                </div>
            </div>
        </div>
        <div class="mt-4">
            <VuePerfectScrollbar class="scroll-area--config-pancake list-seeder vx-col w-full" :settings="settings"
                :key="$vs.rtl">
                <draggable @end="endMove($event)" :list="dataConfig" v-bind="dragOptions" @start="isDraging = true"
                    handle=".handle">
                    <transition-group type="transition" :name="!isDraging ? 'flip-list' : null">
                        <div v-for="(item, index) in dataConfig" :key="index" class="vx-card px-6 py-2 mt-4 ">
                            <div class="vx-row">
                                <div
                                    :class="isChangeConfig ? 'vx-col w-1/12 flex item-center justify-center' : 'hidden'">
                                    <feather-icon svg-classes="h-6 w-6" icon="MenuIcon"
                                        class="text-primary handle"></feather-icon>
                                </div>
                                <div
                                    :class="isChangeConfig ? 'vx-col lg:w-10/12 w-full lg:mt-0 mt-2' : 'vx-col w-full'">
                                    <div style="float:right;" class="mt-16">
                                        <vx-tooltip class="position-icon" :text="$t('button.delete')" position="top">
                                            <feather-icon icon="TrashIcon" class="text-danger"
                                                svgClasses="h-5 w-5 cursor-pointer" @click.stop="confirmDelete(item)" />
                                        </vx-tooltip>
                                    </div>
                                    <div class="vx-row mt-4">
                                        <div class="vx-col lg:w-1/3 w-full lg:mt-0 mt-2">
                                            <label class="vs-input--label">Phòng ban</label>
                                            <v-select class="" v-model="item.departmentId" :clearable="false"
                                                :options="departmentOptions" :reduce="option => option.value"
                                                :disabled="!isChangeConfig" @input="checkDepartment($event)">
                                                <template #option="{ label, organizationBranchName }">
                                                    <h5 style="margin: 0">{{ label }}</h5>
                                                    <em>{{ organizationBranchName }}</em>
                                                </template>
                                                <template #selected-option="{ label, organizationBranchName }">
                                                    <div class="flex items-center gap-2">
                                                        <strong>{{ label }}</strong>
                                                        <em>{{ organizationBranchName }}</em>
                                                    </div>
                                                </template>

                                            </v-select>
                                            <span class="text-danger text-sm">{{ errors.first('title') }}</span>
                                        </div>
                                        <div class="vx-col lg:w-2/3 w-full lg:mt-0 mt-2">
                                            <label class="vs-input--label">Token Pancake</label>
                                            <vs-textarea v-model="item.token" class="w-full" v-validate="'required'"
                                                name="phoneNumber" :disabled="!isChangeConfig" />
                                            <span class="text-danger text-sm">{{ errors.first('title') }}</span>
                                        </div>
                                    
                                        <!--                                        <vs-divider><span>Seeder</span></vs-divider>-->
                                        <!--                                        <VuePerfectScrollbar class="scroll-area list-seeder vx-col w-full" :settings="settings" :key="$vs.rtl">-->
                                        <!--                                            <div class="my-2" v-for="(seeder, ind) in item.seeders" :key="ind" v-if="item.seeders && item.seeders.length > 0">-->
                                        <!--                                                <div class="vx-row">-->
                                        <!--                                                    <div-->
                                        <!--                                                        :class="isChangeConfig ? 'vx-col lg:w-5/12 w-full lg:mt-0 mt-2' : 'vx-col lg:w-1/2 w-full'">-->
                                        <!--                                                        <label class="vs-input&#45;&#45;label">Tên</label>-->
                                        <!--                                                        <vs-input class="w-full" v-model="seeder.name" :disabled="!isChangeConfig"></vs-input>-->
                                        <!--                                                    </div>-->
                                        <!--                                                    <div-->
                                        <!--                                                        :class="isChangeConfig ? 'vx-col lg:w-5/12 w-full lg:mt-0 mt-2' : 'vx-col lg:w-1/2 w-full'">-->
                                        <!--                                                        <label class="vs-input&#45;&#45;label">Facebook ID</label>-->
                                        <!--                                                        <vs-input class="w-full" v-model="seeder.facebookId" :disabled="!isChangeConfig"></vs-input>-->
                                        <!--                                                    </div>-->
                                        <!--                                                    <div-->
                                        <!--                                                        :class="isChangeConfig ? 'vx-col w-2/12 flex item-center justify-center' : 'hidden'">-->
                                        <!--                                                        <vx-tooltip :text="$t('button.add')" v-if="ind === item.seeders.length - 1"-->
                                        <!--                                                                    class="flex items-center">-->
                                        <!--                                                            <feather-icon svg-classes="h-6 w-6" icon="PlusIcon" class="text-success mt-6"-->
                                        <!--                                                                          @click="addItemSeeder(index, ind)"></feather-icon>-->
                                        <!--                                                        </vx-tooltip>-->
                                        <!--                                                        <vx-tooltip :text="$t('button.delete')" v-if="dataConfig.length > 1"-->
                                        <!--                                                                    class="flex items-center">-->
                                        <!--                                                            <feather-icon svg-classes="h-6 w-6" icon="XIcon" class="text-danger mt-6"-->
                                        <!--                                                                          @click="removeItemSeeder(index, ind)" v-if="item.seeders.length > 1"></feather-icon>-->
                                        <!--                                                        </vx-tooltip>-->
                                        <!--                                                    </div>-->
                                        <!--                                                </div>-->
                                        <!--                                            </div>-->
                                        <!--                                        </VuePerfectScrollbar>-->
                                    </div>
                                </div>
                                <div
                                    :class="isChangeConfig ? 'vx-col w-1/12 flex item-center justify-center' : 'hidden'">
                                    <vx-tooltip :text="$t('button.delete')" v-if="dataConfig.length > 1"
                                        class="flex items-center">
                                        <feather-icon svg-classes="h-6 w-6" icon="XSquareIcon" class="text-danger"
                                            @click="removeItem(index)"></feather-icon>
                                    </vx-tooltip>
                                </div>
                            </div>
                        </div>
                    </transition-group>
                </draggable>

                <div class="mt-8" v-if="isChangeConfig">
                    <vs-button icon-pack="feather" icon="icon-plus" @click="addItem">{{ $t('settings.add')
                        }}</vs-button>
                </div>
            </VuePerfectScrollbar>

        </div>
    </div>
</template>

<script>
import draggable from 'vuedraggable';
import vSelect from 'vue-select';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';

export default {
    name: "PancakeToken",
    components: {
        draggable,
        vSelect,
        VuePerfectScrollbar,
    },

    data() {
        return {
            departmentOptions: [
                { value: 0, label: 'Gọi thường' },
                { value: 1, label: 'Gọi OTT' },
            ],
            isChangeConfig: false,
            dataConfig: [],
            isDraging: false,
            settings: {
                maxScrollbarLength: 60,
                wheelSpeed: .30,
            },
        }
    },

    computed: {
        dragOptions() {
            return {
                animation: 200,
                group: "description",
                disabled: false,
                ghostClass: "ghost"
            };
        }
    },


    async created() {
        let userInfo = JSON.parse(localStorage.getItem('userInfo'));
        if (userInfo.userRole === 'organization') await this.getAllDepartment();
        if (userInfo.userRole === 'user') await this.getDepartmentMonitor();
        this.getConfigDepartmentPancake();
    },

    methods: {
        getConfigDepartmentPancake() {
            this.$vs.loading();

            this.$crm.get('/setting/organization-pancake-config/find-config-by-organization-id').then(res => {
                this.$vs.loading.close();
                this.dataConfig = res.data
            }).catch(err => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    title: 'Lỗi',
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            })
        },

        endMove() {
            this.isDraging = false;
            // if (this.dataConfig && this.dataConfig.length > 0) {
            //     this.dataConfig.forEach((el, index) => {
            //         return el.order = index;
            //     });
            // }
        },
        confirmDelete(data) {
            this.$vs.dialog({
                title: 'Xác nhận xóa',
                type: 'confirm',
                color: 'danger',
                text: 'Bạn có chắc chắn muốn xóa phòng ban này không?',
                accept: () => this.deleteRecord(data),
                acceptText: "Xoá",
                cancelText: "Huỷ"
            })
        },

        deleteRecord(data) {
            this.$vs.loading();
            this.$crm.get(`/setting/organization-pancake-config/delete-config-by-department-id?departmentId=${data.departmentId}`).then(() => {
                this.$vs.loading.close();
                this.$vs.notify({
                    text: 'Xóa thành công!',
                    iconPack: 'feather',
                    icon: 'icon-check-circle',
                    color: 'success'
                });
                this.getDataSeeder();
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },

        checkDataSave() {
            let isDuplicate = false;
            let arr = this.dataConfig;
            for (let el of arr) {
                let result = this.dataConfig.filter(x => x.departmentId === el.departmentId)
                if (result.length > 1) {
                    isDuplicate = true;
                    this.$vs.notify({
                        text: 'Tồn tại phòng ban trung nhau. Vui lòng chọn phòng ban khác!',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                    break;
                }
                if (arr.indexOf(el) === arr.length - 1 && !isDuplicate) {
                    this.dataConfig = this.dataConfig.map(el => {
                        el.seeders = el.seeders.filter(x => x.name && x.facebookId && x.name.trim() !== '' && x.facebookId.trim() !== '')
                        if (el.seeders.length === 0) el.seeders = null;
                        return el;
                    })
                    setTimeout(() => {
                        this.saveData()
                    }, 500)
                }
            }
        },

        saveData() {
            this.$vs.loading();
            this.$crm.post('/setting/organization-pancake-config/save-all', this.dataConfig).then(() => {
                this.$vs.loading.close();
                this.$vs.notify({
                    text: 'Cập nhật cấu hình tổng đài thành công!',
                    iconPack: 'feather',
                    icon: 'icon-check-circle',
                    color: 'success'
                });
                this.isChangeConfig = false;
                this.getConfigDepartmentPancake();
            }).catch(err => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    title: 'Lỗi',
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            })
        },

        cancelSetting() {
            this.isChangeConfig = false;
            this.getConfigDepartmentPancake();
        },

        addItem() {
            this.dataConfig.push({ departmentId: null, token: null, seeders: [{ name: null, facebookId: null }] })
        },
        removeItem(index) {
            this.dataConfig.splice(index, 1);
        },

        getAllDepartment() {
            return new Promise((resolve, reject) => {
                this.$vs.loading();
                this.$crm.post('/department/find-by-condition', {}).then(res => {
                    let branchList = JSON.parse(localStorage.getItem('branchInfoList'))
                    this.departmentOptions = res.data.map(el => {
                        return {
                            value: el.id,
                            label: el.departmentName,
                            organizationBranchName: branchList.find(x => x.id === el.organizationBranchId).organizationBranchName
                        }
                    });
                    resolve(res);
                    this.$vs.loading.close();
                }).catch((err) => {
                    reject(err);
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        title: 'Error',
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                });
            })
        },

        getDepartmentMonitor() {
        },

        checkDepartment(evt) {
            let result = this.dataConfig.filter(el => el.departmentId === evt)
            if (result.length > 1) {
                return this.$vs.notify({
                    text: 'Phòng ban đã tồn tại. Vui lòng chọn phòng ban khác!',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            }
        },

        changeConfig() {
            this.dataConfig = this.dataConfig.map(el => {
                if (!el.seeders) el.seeders = [{ name: null, facebookId: null }]
                return el;
            })
            this.isChangeConfig = true
        },

        removeItemSeeder(index, ind) {
            this.dataConfig[index].seeders.splice(ind, 1);
        },

        addItemSeeder(index, ind) {
            this.dataConfig[index].seeders.push({ name: null, facebookId: null })
        }
    }
}
</script>

<style lang="scss">
.list-seeder {
    height: 200px;
}

.scroll-area--config-pancake {
    height: calc(var(--vh, 1vh) * 100 - 232px)
}
</style>
